import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options", "type", "label", "fieldType", "optionsUrl", "referencedObjectType"],
  _excluded2 = ["options", "type", "fieldType"];
import OutputTypeDefinitionOption from 'automation-ui-flow-core/fields/OutputTypeDefinitionOption';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class OutputTypeDefinition extends createImmutableObjectClass({
  name: '',
  // We allow this field to be null in the FE
  type: null,
  label: null,
  fieldType: null,
  options: [],
  optionsUrl: null,
  referencedObjectType: null,
  externalOptions: false
}, {
  fromJSON: _ref => {
    let {
        options,
        type,
        label,
        fieldType,
        optionsUrl,
        referencedObjectType
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({
      options: options.map(option => new OutputTypeDefinitionOption(option)),
      type: type,
      label,
      fieldType: fieldType,
      optionsUrl,
      referencedObjectType
    }, rest);
  },
  toJSON: _ref2 => {
    let {
        options,
        type,
        fieldType
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      options: options.map(option => option.toJSON()),
      type: type,
      fieldType: fieldType
    }, rest);
  }
}) {
  getLabel() {
    return this.label;
  }
  setName(newName) {
    return this.set('name', newName);
  }
  getName() {
    return this.name;
  }
  getType() {
    return this.type;
  }
  getOptions() {
    return this.options;
  }
  getOptionsAsSelectOptions() {
    const optionRecords = this.options;
    return optionRecords ? optionRecords.map(opt => opt.getAsSelectOption()) : null;
  }
}